import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _this = this;
import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, getAppId } from "@/utils/auth"; // get token from cookie
import { getAllApp } from "@/api/user";
import { GlobalData } from "op-ui/dist/global";
import getPageTitle from "@/utils/get-page-title";
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["/login", "/auth-redirect", "/register", "/forget", "/dingding", "/demo", "/applyfor"]; // no redirect whitelist
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(to, from, next) {
    var hasToken, hasAuthMenus, apps, result, umsAnPdmApps, appId, menus, accessMenuRoutes;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          GlobalData.currPageId = to.meta.menuId;
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context4.next = 56;
            break;
          }
          if (!(to.path === "/login")) {
            _context4.next = 10;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: "/"
          });
          NProgress.done();
          _context4.next = 54;
          break;
        case 10:
          // determine whether the user has obtained his permission roles through getInfo
          hasAuthMenus = store.getters.accessedMenu && store.getters.accessedMenu.length > 0;
          if (!hasAuthMenus) {
            _context4.next = 15;
            break;
          }
          next();
          _context4.next = 54;
          break;
        case 15:
          _context4.prev = 15;
          apps = store.state.user.apps ? store.state.user.apps : sessionStorage.getItem("SET_APPS");
          if (!(apps || apps.length < 0)) {
            _context4.next = 36;
            break;
          }
          _context4.next = 20;
          return getAllApp();
        case 20:
          result = _context4.sent;
          if (!(result.code === 200)) {
            _context4.next = 35;
            break;
          }
          if (!(result.data === null)) {
            _context4.next = 27;
            break;
          }
          Message({
            type: "error",
            message: "你没有应用权限请找管理员开通应用权限",
            duration: 5 * 1000,
            onClose: function () {
              var _onClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return store.dispatch("user/resetToken");
                    case 2:
                      next("/login?redirect=".concat(to.path));
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function onClose() {
                return _onClose.apply(this, arguments);
              }
              return onClose;
            }()
          });
          return _context4.abrupt("return");
        case 27:
          if (!(result.data.length > 0)) {
            _context4.next = 32;
            break;
          }
          umsAnPdmApps = result.data.filter(function (p) {
            return p.appCode === process.env.VUE_APP_APP_CODE;
          });
          if (!(umsAnPdmApps.length < 1)) {
            _context4.next = 32;
            break;
          }
          Message({
            type: "error",
            message: "你没有应用权限请找管理员开通应用权限",
            duration: 5 * 1000,
            onClose: function () {
              var _onClose2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return store.dispatch("user/resetToken");
                    case 2:
                      next("/login?redirect=".concat(to.path));
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              function onClose() {
                return _onClose2.apply(this, arguments);
              }
              return onClose;
            }()
          });
          return _context4.abrupt("return");
        case 32:
          store.dispatch("user/setApps", result.data);
          // store.commit("user/SET_APPS", result.data)
          // sessionStorage.setItem("SET_APPS", JSON.stringify(result.data))
          _context4.next = 36;
          break;
        case 35:
          _this.$message({
            type: "error",
            message: result.msg
          });
        case 36:
          appId = getAppId(); // get user menu info
          _context4.next = 39;
          return store.dispatch("user/getMenus", appId);
        case 39:
          menus = _context4.sent;
          _context4.next = 42;
          return store.dispatch("permission/generateMenuRoutes", menus);
        case 42:
          accessMenuRoutes = _context4.sent;
          if (!(!accessMenuRoutes || accessMenuRoutes.length <= 0)) {
            _context4.next = 45;
            break;
          }
          throw new Error("用户菜单权限获取失败，请重新登陆");
        case 45:
          store.commit("user/SET_ACCESSEDMENU", accessMenuRoutes);
          // dynamically add accessible routes
          router.addRoutes(accessMenuRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context4.next = 54;
          break;
        case 50:
          _context4.prev = 50;
          _context4.t0 = _context4["catch"](15);
          // remove token and go to login page to re-login
          Message({
            message: _context4.t0.message || "获取菜单权限失败，请重新登陆",
            type: "error",
            duration: 5 * 1000,
            onClose: function () {
              var _onClose3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return store.dispatch("user/resetToken");
                    case 2:
                      next("/login?redirect=".concat(to.path));
                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function onClose() {
                return _onClose3.apply(this, arguments);
              }
              return onClose;
            }()
          });
          NProgress.done();
        case 54:
          _context4.next = 57;
          break;
        case 56:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 57:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[15, 50]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});